/*
* user-portrait ctrl
* */

;(function () {
    userPortraitCtrl.$inject = ['$timeout', '$http', '$q'];
    angular.module('DSSXAPP', ['app.core']);

    angular
        .module('DSSXAPP')
        .controller('UserPortraitCtrl', userPortraitCtrl);

    var ThumbnailHelper = (function () {
        function Helper() {
        }

        Helper.prototype = {
            init: function (option) {
                this.width = option.width;
                this.height = option.height;

                this.selectWidth = option.selectWidth;
                this.selectHeight = option.selectHeight;

                this.targetWidth = option.targetWidth;
                this.targetHeight = option.targetHeight;

                this.scaleRect = this.getScaleRect();

                this.margin = null;

                this.style = null;

                this.updateStyle();

                return this;
            },
            getScaleRect: function () {
                var w = this.width * this.targetWidth / this.selectWidth;
                var h = this.height * this.targetHeight / this.selectHeight;

                w = +w.toFixed(2);
                h = +h.toFixed(2);

                return {width: w, height: h};
            },
            updateVisualArea: function (c) {
                this.selectWidth = c.w;
                this.selectHeight = c.h;
                this.scaleRect = this.getScaleRect();

                var left = this.width * c.x / this.selectWidth;
                var top = this.height * c.y / this.selectHeight;

                left = -left.toFixed(2);
                top = -top.toFixed(2);
                this.margin = {left: left, top: top};

                this.updateStyle();
                return this.margin;
            },
            updateStyle: function () {
                var scaleRect = this.scaleRect;
                var margin = this.margin;
                this.style = {
                    width: scaleRect.width + 'px',
                    height: scaleRect.height + 'px'
                };
                if (margin) {
                    this.style.marginLeft = this.margin.left + 'px';
                    this.style.marginTop = this.margin.top + 'px';
                }
            }
        };
        return Helper;
    })();


    function userPortraitCtrl($timeout, $http, $q) {
        this.$onInit = onInit;

        var vm = this;

        var imgUploadInput, jCropImg, jCropInterface,
            jCropImgScaleRect; // 图片裁剪显示时缩放的大小

        var firstPageLoaderId = layer && layer.load(1, {shade: 0.2});

        function onInit() {
            bindVM();
            initUploadAndCrop();

            beLoadPerInfo()
              .catch(function (reason) {
                  console.log('[UserPortraitCtrl]:beLoadPerInfo', reason)
                  return {}
              })
              .then(function (res) {
                var data = res.data || {};
                vm.d.avatarDataUrl = data.personalInfo && (data.personalInfo.photo || '');

                if (firstPageLoaderId) {
                    layer.close(firstPageLoaderId);
                    firstPageLoaderId = null;
                }
            });
        }

        function bindVM() {

            vm.d = {
                // 头像的 data url
                avatarDataUrl: '',

                // 用于 crop 编辑的图片 url
                cropUrl: '',
                // cropImgRect: null,
                successTip: '',
                errorTip: ''
            };

            vm.f = {
                modifyAvatar: modifyAvatar,
                togglePageMod: togglePageMod,
                submitButtonOnClick: submitButtonOnClick
            };


            // config or control
            vm.c = {
                uploadBoxDisplay: true,
                cropBoxDisplay: false,
                // uploadBoxDisplay: false,
                // cropBoxDisplay: true,
                // successTip: false,
                // errorTip: false,

                // crop 编辑的图片的大小
                cropImgRect: null,
                cropImgRectStyle: null,

                thum: null,  // thumbnail
                thumSmall: null, // small thumbnail

                //
                promise: false
            };
        }

        function modifyAvatar() {
            imgUploadInput.val('');
            imgUploadInput.trigger('click');
        }

        function initUploadAndCrop() {
            imgUploadInput = $('#img-upload-input');
            jCropInterface = $('#jcrop-interface');
            jCropImg = $('#jcrop-img');

            imgUploadInput.on('change', imgInputOnchange);
            jCropInterface.on('cropmove cropend', updateCropSelection);
        }

        /**
         * resetThumbnailHelper
         * @param rect 目标图片的修剪时显示的大小
         */
        function resetThumbnailHelper(rect) {
            var c = vm.c, h, option,
                selectWidth = 91, selectHeight = 91;

            option = {
                selectWidth: selectWidth,
                selectHeight: selectHeight,
                targetWidth: rect.width,
                targetHeight: rect.height
            };

            h = new ThumbnailHelper();
            option.width = 150;
            option.height = 150;
            h.init(option);
            c.thum = h;

            h = new ThumbnailHelper();
            option.width = 60;
            option.height = 60;
            h.init(option);
            c.thumSmall = h;
        }

        function imgInputOnchange(ev) {
            // console.log('[UserPortraitCtrl:imgInputOnchange]', ev)

            $timeout(function () {
                hideErrorTip();
                hideSuccessTip();
                handlerImageFile(ev.target.files[0])
            })
        }

        function handlerImageFile(file) {
            var SIZE_LIMIT = 3 * 1024 * 1024,
                TYPE_LIMITS = {'image/jpeg': 1};

            if (!file || file.size === 0) {
                layer.msg('图片不能为空');

                console.log('[UserPortraitCtrl:handlerImageFile] file is empty', file);
                return;
            }

            if (file.size > SIZE_LIMIT) {
                showErrorTip(file.name + '  文件超过3M，上传失败');
                return;
            }

            if (!TYPE_LIMITS[file.type]) {
                showErrorTip(file.name + ' 文件类型错误');
                return;
            }

            hideErrorTip();

            var reader = new FileReader();
            reader.onload = function () {
                var result = this.result;
                if (!result) {
                    // todo
                    console.log('[UserPortraitCtrl:handlerImageFile] read data url error', this);
                    return;
                }
                file.value = '';

                $timeout(function () {
                    showCropBox(result);
                })
            };
            reader.readAsDataURL(file);
        }

        function showCropBox(url) {
            if (!url) {
                console.log('[UserPortraitCtrl:showCropBox] url is empty');
                return;
            }

            var cropWrapWidth = 490;
            var cropWrapHeight = 250;

            hideSuccessTip();
            hideErrorTip();
            togglePageMod('crop');
            jCropImg.one('load', function () {
                $timeout(imageOnLoad);
            });
            vm.d.cropUrl = url;

            var rect;

            function imageOnLoad() {
                var img, w, h;
                img = jCropImg[0];
                h = img.naturalHeight;
                w = img.naturalWidth;

                rect = scaleImageSize(w, h, cropWrapWidth, cropWrapHeight);
                jCropImgScaleRect = rect;
                updateCropImgRect(rect);

                $timeout(resetJcrop)
            }

            function resetJcrop() {
                resetThumbnailHelper(rect);

                var jcropApi;
                jcropApi = jCropImg.Jcrop('api');
                jcropApi && jcropApi.destroy();

                jCropImg.Jcrop({
                    aspectRatio: 1,
                    setSelect: [0, 0, 91, 91]
                });
                jcropApi = jCropImg.Jcrop('api');
                if (jcropApi && jcropApi.container) {
                    jcropApi.container.width(rect.width).height(rect.height);
                }
            }

            function updateCropImgRect(rect) {
                vm.c.cropImgRect = {
                    width: rect.width,
                    height: rect.height
                };

                vm.c.cropImgRectStyle = {
                    width: rect.width + 'px',
                    height: rect.height + 'px'
                };
            }
        }

        function updateCropSelection(e, s, c) {
            $timeout(function () {
                vm.c.thum.updateVisualArea(c);
                vm.c.thumSmall.updateVisualArea(c);

                // getCropSelectionImage();
            });
        }


        function submitButtonOnClick() {
            var id = layer.load(1, {shade: 0.2});
            var data = getCropSelectionImage();

            if (!data) {
                layer.close(id);
                showErrorTip('转换图片失败');
                return;
            }

            beUploadBase64Pic({fileName: 'unnamed.jpg', name: 'unnamed.jpg'}, data)
                .then(updateAvatar)
                .catch(function () {
                    showErrorTip('系统繁忙，请稍后重试');
                })
                .then(function () {
                    hideErrorTip();
                    showSuccessTip('您的照片上传成功！');
                    togglePageMod('upload');
                })
                .finally(function () {
                    layer.close(id);
                });

            function updateAvatar(res) {
                var data = res.data || {};
                if (!data) {
                    console.log('[UserPortraitCtrl] updateAvatar 获取上传图片地址错误');
                    return $q.reject('获取上传图片地址错误');
                }
                return beUpdatePerInfo({}, {photo: data}).then(function () {
                    vm.d.avatarDataUrl = data || '';
                });
            }
        }

        function getCropSelectionImage() {
            var jcropApi;
            jcropApi = jCropImg.Jcrop('api');
            if (!jcropApi) {
                console.log('[UserPortraitCtrl] getCropSelectionImage: jcrop is not init');
                return;
            }

            var cropImgRect = jCropImgScaleRect,
                canvas = $('<canvas></canvas>')[0],
                // canvas = $('#cvs')[0],
                ctx2d,
                selection = jcropApi.ui.selection.last,
                ratio,
                trc, // thumbnail rect - 要裁剪头像的大小位置
                nrc, // natural rect - 裁剪图片原始大小位置
                dataUrl,
                base64Data,
                originImg = jCropImg[0];

            ratio = originImg.naturalWidth / cropImgRect.width;

            trc = {x: 0, y: 0, width: 100, height: 100};

            nrc = {
                x: ratio * selection.x,
                y: ratio * selection.y,
                width: ratio * selection.w,
                height: ratio * selection.h
            };

            canvas.width = trc.width;
            canvas.height = trc.height;
            ctx2d = canvas.getContext('2d');

            try {
                // console.log(nrc.x, nrc.y, nrc.width, nrc.height, trc.x, trc.y, trc.width, trc.height);
                ctx2d.drawImage(originImg, nrc.x, nrc.y, nrc.width, nrc.height, trc.x, trc.y, trc.width, trc.height);
            } catch (e) {
                console.error('[UserPortraitCtrl] getCropSelectionImage: canvas drawImage error', e);
                return '';
            }
            dataUrl = canvas.toDataURL('image/jpeg');
            base64Data = dataUrl.slice('data:image/jpeg;base64,'.length);
            return base64Data;
        }

        function beUploadBase64Pic(params, data) {
            var p = angular.extend({
                    m: 'C',
                    pub: '1',
                    picType: '1',
                    fileName: 'unnamed.png',
                    name: 'unnamed.png'
                }, params, {base64: 1, token: DSSX.util.getToken()}),
                fsHost = '//' + DSSX.host.fs + '/usr/api/uload';


            return $http({
                method: 'POST',
                url: fsHost + '?' + $.param(p),
                data: data,
                headers: {'Content-Type': 'multipart/form-data'}
            }).then(httpResponseCodeHandler);
        }

        function beLoadPerInfo(params) {
            params = params || {};
            params.token = DSSX.util.getToken();
            return $http({
                url: '/usr/api/loadPerInfo',
                method: 'GET',
                params: params
            }).then(httpResponseCodeHandler, httpResponseErrorTipHandler);
        }

        function beUpdatePerInfo(params, data) {
            params = params || {};
            params.token = DSSX.util.getToken();
            return $http({
                url: '/usr/api/updatePerInfo',
                method: 'POST',
                params: params,
                data: data
            }).then(httpResponseCodeHandler, httpResponseErrorTipHandler);
        }

        function togglePageMod(mod) {
            var c = vm.c;
            switch (mod) {
                case 'crop':
                    c.cropBoxDisplay = true;
                    c.uploadBoxDisplay = false;
                    break;
                case 'upload':
                    c.cropBoxDisplay = false;
                    c.uploadBoxDisplay = true;
                    break;
                default:
                    break;
            }
        }

        function hideSuccessTip() {
            vm.d.successTip = '';
        }

        function hideErrorTip() {
            vm.d.errorTip = '';
        }

        function showSuccessTip(msg) {
            vm.d.successTip = msg;
        }

        function showErrorTip(msg) {
            vm.d.errorTip = msg;
        }


        /**
         * 返回新的矩形 该矩形的宽高比列和矩形A一致，并且是矩形B中能容纳最大的矩形
         * @param a_width 矩形A的宽
         * @param a_height 矩形A的高
         * @param b_width 矩形B的宽
         * @param b_height 矩形B的高
         * @return {{width: number, height: number}}
         */
        function scaleImageSize(a_width, a_height, b_width, b_height) {
            var rw = a_width / b_width;
            var rh = a_height / b_height;
            var rr = a_width / a_height;
            if (rw > rh) {
                a_width = b_width;
                a_height = a_width / rr;
            } else if (rw < rh) {
                a_height = b_height;
                a_width = a_height * rr;
            } else {
                a_width = b_width;
                a_height = b_height;
            }
            return {width: a_width, height: a_height};
        }


        function httpResponseCodeHandler(arg) {
            arg = arg || {};
            var res = arg.data || {};
            if (res.code !== 0) {
                if (res.code === 301) {
                    DSSX.util.handle301(res.data);
                }
                return $q.reject(arg);
            }
            return res;
        }

        function httpResponseErrorTipHandler(err) {
            console.log('httpResponseErrorTipHandler', err);
            var excludeCodes = [301];
            var xhrResponse = err.data;

            // 部分 code 不显示提示
            if (excludeCodes.indexOf(code) > -1) {
                return $q.reject(err);
            }
            var reason = xhrResponse.msg ? (xhrResponse.msg + ' ') : '';
            reason += xhrResponse.dmsg || '';

            layer && layer.msg(reason);
            return $q.reject(err);
        }
    }
}());
